import transformBackgroundImage from "theme/libs/wordpress/utils/transformBackgroundImage";
import transformBackgroundVideo from "theme/libs/wordpress/utils/transformBackgroundVideo";
import transformColor from "./transformColor";

/**
 * FlexibleBackground can be a image-, video- or a colored background.
 * This function checks the type of the FlexibleBackground and transforms the data accordingly.
 * @param {object|object[]} background - Background data straight from the cms.
 * @param {string} fallbackType - Pass a fallback for background.layout if you are sure of the background type.
 * @param {object} - Transformed background data with a value for mobile and desktop.
 */

const transformer = (background, fallbackType, posterWidth) => {
    // Break out data from array/object if necessary
    if (background && background[0]) {
        background = background[0];
    }

    // Check if there is any content
    if (!background) {
        return false;
    }

    // Get the background type
    const type = background.layout || fallbackType;

    // Use the type to get the data since the data is named "background_*type*"
    let data = background[`background_${type}`];

    // Sometimes the background data is found directly inside the background object
    if (!data) {
        data = background;
    }

    // Transform the data depending on the type
    switch (type) {
        case "color": {
            // Returns an empty string with the color.
            return transformColor(data);
        }

        case "image":
            // Returns a transformed backgroundImageObject.
            data = transformBackgroundImage(data);
            data.type = type;
            return data;

        case "video":
            // Returns a transformed backgroundVideoObject.
            data = transformBackgroundVideo(data);
            data.mediaQuery = { auto: "format", q: 70, w: posterWidth };
            data.type = type;
            return data;

        default:
            console.warn(`Type: ${type}, not found in transformFlexibleBackground`);
            break;
    }
    return false;
};

export default (backgroundData, type, posterWidth = { desktop: 1400, mobile: 500 }) => {
    if (backgroundData) {
        // desktop and mobile makes it possible to use different background on different devices.
        const { desktop, mobile } = backgroundData;
        return {
            desktop: transformer(desktop, type, posterWidth.desktop),
            mobile: transformer(mobile, type, posterWidth.mobile),
        };
    }

    return {
        desktop: undefined,
        mobile: undefined,
    };
};
